import {
  DialogContent as MUIDialogContent,
  DialogContentProps,
} from '@mui/material';
import React from 'react';

export const DialogContent = (props: DialogContentProps) => (
  <MUIDialogContent {...props} />
);
